import { __awaiter } from '../../../../../_virtual/_tslib.js';
import { useState, useCallback } from 'react';
import '../../constants/colors.js';
import '@dynamic-labs/multi-wallet';
import '@dynamic-labs/sdk-api';
import '../../../shared/logger.js';
import '@dynamic-labs/iconic';
import 'react/jsx-runtime';
import '../../../context/ViewContext/ViewContext.js';
import { isWalletConnected } from '../../functions/isWalletConnected/isWalletConnected.js';

const useWalletsConnectionState = (linkedWallets) => {
    const [connectedWalletMap, setConnectedWalletMap] = useState();
    const computeConnectedStateForWallets = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const connectedWalletIds = (yield Promise.all(linkedWallets.map((wallet) => __awaiter(void 0, void 0, void 0, function* () {
            const isConnected = yield isWalletConnected(wallet);
            if (isConnected) {
                return wallet.id;
            }
            else {
                return undefined;
            }
        })))).filter((connectedWalletId) => connectedWalletId !== undefined);
        const newConnectedStateByWalletIdMap = connectedWalletIds.reduce((result, walletId) => (Object.assign(Object.assign({}, result), { [walletId]: true })), {});
        setConnectedWalletMap(newConnectedStateByWalletIdMap);
    }), [linkedWallets, setConnectedWalletMap]);
    return {
        computeConnectedStateForWallets,
        connectedWalletMap: connectedWalletMap !== null && connectedWalletMap !== void 0 ? connectedWalletMap : {},
        didConnectedStateLoad: Boolean(connectedWalletMap),
    };
};

export { useWalletsConnectionState };
